import React, { useEffect, useState } from 'react';
import { DeliveryMethodSortingSettings, DeliverySettingsSortingMethod } from '../../../../models/CheckoutGroupSettings';
import RadioButtonGroup, { RadioButtonOption } from '@app/react-common/components/radio-button-group/RadioButtonGroup';
import { CheckoutSettings } from '@pdqdev/pdq-shared/dist/entities';
import Tooltip from '@app/react-common/components/tooltip/Tooltip';
import Input from '@app/react-common/components/input/Input';

interface DeliveryMethodSortingProps {
  checkoutSettings: CheckoutSettings;
  deliveryMethodSortingSettings?: DeliveryMethodSortingSettings;
  onChange: (deliveryMethodSortingSettings: DeliveryMethodSortingSettings) => void;
}

export const DeliveryMethodSortingSettingsView: React.FC<DeliveryMethodSortingProps> = (props) => {
  const [state, setState] = useState<DeliveryMethodSortingSettings>(props?.deliveryMethodSortingSettings ?? null);

  useEffect(() => {
    if (
      state.deliveryMethodSortingMode == DeliverySettingsSortingMethod.PriorityMethod &&
      !state.deliveryMethodSortingPriorityMethod?.length
    ) {
      setState({ ...state, deliveryMethodSortingPriorityMethod: [''] });
    }
    props.onChange(state);
  }, [state]);

  return (
    <div className="delivery-method-sorting">
      <div className="delivery-method-sorting__title-container">
        <div className="delivery-method-sorting__title">
          <h3>Delivery Method Sorting</h3>
          {!props.checkoutSettings?.enableDeliveryCustomization && (
            <Tooltip
              tooltipText={
                'To utilize Delivery Method Sorting, please enable Delivery Customization in Checkout Settings'
              }>
              <i className="icon icon-more_information" />
            </Tooltip>
          )}
        </div>
        <div className="delivery-method-sorting__secondary-label">
          The first option will always be the cheapest and selected by default. Sorting will begin from the second
          option in the list.
        </div>
      </div>
      <div>
        <RadioButtonGroup
          options={[
            { label: 'Cheapest method (default)', value: null },
            { label: 'Second cheapest method', value: DeliverySettingsSortingMethod.SecondCheapest },
            {
              label: 'Most expensive method',
              value: DeliverySettingsSortingMethod.MostExpensiveToLeastExpensive,
            },
            {
              label: 'A specific method',
              value: DeliverySettingsSortingMethod.PriorityMethod,
            },
          ]}
          disabled={!props.checkoutSettings?.enableDeliveryCustomization}
          defaultOptionValue={state?.deliveryMethodSortingMode || null}
          onChange={(selectedOption: RadioButtonOption) => {
            const nextState = {
              ...state,
              deliveryMethodSortingMode: selectedOption.value,
            };
            setState(nextState);
          }}
        />
        {state.deliveryMethodSortingMode === DeliverySettingsSortingMethod.PriorityMethod && (
          <div className="delivery-method-sorting__multiple-priority-methods">
            {state.deliveryMethodSortingPriorityMethod?.map((method, index) => {
              return (
                <div className="delivery-method-sorting__priority-method">
                  <Input
                    wrapperDivClassName="delivery-method-sorting__priority-method-input"
                    type={'text'}
                    value={method}
                    fullWidth={true}
                    placeholder={`Shipping method ${index + 1}`}
                    onChange={(e) => {
                      const newMethods = [...state.deliveryMethodSortingPriorityMethod];
                      newMethods[index] = e.target.value;
                      setState({ ...state, deliveryMethodSortingPriorityMethod: newMethods });
                    }}></Input>
                  <Tooltip tooltipText={'Delete rule'} appearOnSide="top">
                    <div
                      onClick={() => {
                        const newMethods = [...state.deliveryMethodSortingPriorityMethod];
                        newMethods.splice(index, 1);
                        setState({ ...state, deliveryMethodSortingPriorityMethod: newMethods });
                      }}>
                      <i className="icon icon-close delivery-method-sorting__delete-priority-method"></i>
                    </div>
                  </Tooltip>
                </div>
              );
            })}
            <div>
              <span className="delivery-method-sorting__when-available">
                when available, otherwise default to cheapest or&nbsp;
                <span
                  className="delivery-method-sorting__add-another"
                  onClick={() => {
                    const newMethods = [...state.deliveryMethodSortingPriorityMethod];
                    newMethods.push('');
                    setState({ ...state, deliveryMethodSortingPriorityMethod: newMethods });
                  }}>
                  add another method
                </span>
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
